module.exports = __webpack_public_path__ + "assets/44f534bb8b61bc249d6328a050b1eb6a.mp3";